import { BrowserRouter, Route, Routes } from "react-router-dom";
import { NotFound } from "../modules/404";

import { Login } from "../modules/login";
import { Codart } from "../modules/codarts/pages";

export const LoggedOutRouter = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Codart />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
};
